import { executeRequest, Request } from '@jfs/network'
import { actionMenuStrings } from '../../src/data/static/strings'
import { RootStore } from '../../src/data/store'
import { apiTypes, geRequestDateTimeRoundOff } from '../../src/util/util'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'
import { CampaignsParser } from './parsers/CampaignsParser'

const responseParser = (data: any, metaInfo: any) => {
  const respData = data
  return CampaignsParser(respData?.data?.distribution, metaInfo)
}

const getCampaigns = (req: any, tokens: any, metaInfo: any) => {
  const isCustomRange = RootStore.campaigns.selectedDateInfo.dateLabel === actionMenuStrings.customDate
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: `${APIEndPoints.getCampaigns}`,
    method: 'POST',
    cache: false,
    body: isCustomRange ? req : geRequestDateTimeRoundOff(req, RootStore.campaigns.selectedDateInfo, apiTypes.CAMPAIGN),
  }
  return executeRequest(request).then((data) => {
    return responseParser(data, metaInfo)
  })
}

export { getCampaigns }
